import React, { useRef } from "react";
import { Button, Tooltip } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";

const DynamicImportExport = ({ fileName, data, onImport, removeKeys = [], addDefaultKeys = [] }) => {
  const fileInputRef = useRef(null);

  // -------------------------------
  // 🔹 EXPORT FUNCTION 
  // - remove keys
  // - add default keys
  // -------------------------------
  const handleExport = () => {
    const cleanedData = data.map((item) => {
      let newItem = { ...item };

      // ❌ Remove given keys
      removeKeys?.forEach((key) => delete newItem[key]);

      // ✅ Add default keys if missing
      addDefaultKeys?.forEach(({ key, default: defaultValue }) => {
        if (!(key in newItem)) {
          newItem[key] = defaultValue;
        }
      });

      return newItem;
    });

    const dataStr = JSON.stringify(cleanedData, null, 2);
    const blob = new Blob([dataStr], { type: "application/json" });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = `${fileName}.json`;
    link.click();

    URL.revokeObjectURL(url);
  };

  // -------------------------------
  // 🔹 IMPORT FUNCTION (unchanged)
  // -------------------------------
  const handleImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const imported = JSON.parse(e.target.result);

        if (!Array.isArray(imported)) {
          alert("Invalid file format: expected an array");
          return;
        }

        // ⛔ No key removal here
        onImport(imported);
      } catch (err) {
        console.error("JSON Parse Error:", err);
      }
    };

    reader.readAsText(file);
  };

  return (
    <div>
      <Tooltip title="Export" arrow>
        <Button variant="text" color="primary" onClick={handleExport} style={{ minWidth: "20px" }}>
          <FileDownloadIcon />
        </Button>
      </Tooltip>

      <Tooltip title="Import" arrow>
        <Button variant="text" color="primary" onClick={() => fileInputRef.current.click()} style={{ minWidth: "20px" }}>
          <FileUploadIcon />
        </Button>
      </Tooltip>

      <input
        type="file"
        accept=".json"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleImport}
      />
    </div>
  );
};

export default DynamicImportExport;
